import styled from 'styled-components';
import { Breakpoints } from "../../../../constants/Breakpoints";
import Colors from '../../../../constants/Colors';
import { FontWeight, Text } from '../../../../components/Text';

  const Title = styled(Text)`
  font-size: 12px;
  display: block;
  margin-top: 15px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.GRAY[6]};
  
  @media (min-width: ${Breakpoints.sm}) {
    font-size: 16px;
    margin-top: 0px;
    display: unset;
  }

  @media (min-width: ${Breakpoints.md}) {
    font-size: 18px;
  }
`;


export { Title };